import React, {Component} from 'react';
import i18n from "../../../i18n";
import {YesNoModal} from "../../elements/YesNoModal";
import {FaIcon} from "../../FaIcon";
import {ChannelLogo} from "../../channels/ChannelLogo";
import {ReconnectAdAccountModal} from "../../agency/connections/ReconnectAdAccountModal";
import {LookerCCStatus} from "../../agency/looker_cc/LookerCCStatus";
import {DataNodeStatus} from "../../agency/data_node/DataNodeStatus";
import {MCPStatus} from "../../agency/mcp/MCPStatus";

export class ClientStoreRow extends Component {
    constructor(props) {
        super(props);
        this.handleClientStoreRemove = this.handleClientStoreRemove.bind(this);
        this.handleAdAccountReconnect = this.handleAdAccountReconnect.bind(this);

        this.state = {
            isSaving: this.props.isSaving,
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isSaving !== this.props.isSaving) {
            this.setState({isSaving: this.props.isSaving});
        }
    }

    handleClientStoreRemove() {
        this.props.onRemove(this.props.clientStore.id)
    }

    renderAccessStatus() {
        const icon = this.adAccountIsOk() ? "check" : "exclamation-triangle";
        const extraClassOnError = this.adAccountIsOk() ? "" : "no-impressions-alert";
        const noAccessTextDetail = this.props.clientStore.has_access ? "" : <span style={{fontWeight: "600"}}>Sin acceso desde: {this.props.clientStore.no_access_since}<br/></span>;

        return (
            <div className={"bu-cell-icon " + extraClassOnError}>
                <FaIcon iconName={icon}/>
                <div className="bu-tooltip">
                    <FaIcon iconName={icon}/>
                    <p className="tooltip-description">
                        {noAccessTextDetail}
                        Último chequeo: {this.props.clientStore.last_access_check}
                    </p>
                </div>
            </div>
        );
    }

    adAccountIsOk() {
        return this.props.clientStore.has_access
    }

    getClientColumnData() {
        if (this.props.showClientColumn) {
            return (<td>
                {this.props.clientStore.agency_client_name}
            </td>)
        } else {
            return null;
        }
    }

    handleAdAccountReconnect() {
        this.reconnectModal.toggle();
    }

    render() {
        return (
            <tr key={this.props.clientStore.id}>
                <td style={{paddingLeft: '0.4em'}}>
                    {this.renderAccountColumnText()}
                </td>
                <td>
                    {this.props.clientStore.currency_code}
                </td>
                {this.getClientColumnData()}
                <td>
                    {this.props.clientStore.url}
                </td>
                <td>
                    {this.lookerStudioColumnData()}
                </td>
                <td>
                    {this.dataNodeColumnData()}
                </td>
                <td>
                    {this.mcpColumnData()}
                </td>
                <td>
                    {this.renderAccessStatus()}
                </td>
                <td>
                    <span style={{marginLeft: "5px", cursor: "pointer"}} onClick={this.handleAdAccountReconnect}
                          title="Reconectar cuenta"> <FaIcon iconName="sync-alt"/></span>
                    <ReconnectAdAccountModal ref={instance => { this.reconnectModal = instance; }} adAccountData={this.props.clientStore}/>
                    <span style={{marginLeft: "5px"}}>
                        <YesNoModal onYesAnswer={this.handleClientStoreRemove}
                                    title={i18n.t('client_store_row.unlink_title')}
                                    message={i18n.t('client_store_row.unlink_message')}
                                    question={i18n.t('client_store_row.unlink_question')}
                                    buttonClassName={""}
                                    buttonText={""}
                                    buttonTitle="Desvincular tienda del cliente"
                                    buttonIconName={"minus-square"}
                                    isSaving={this.state.isSaving}
                        />
                    </span>
                </td>
            </tr>
        );
    }

    lookerStudioColumnData() {
        return <LookerCCStatus hasConnection={this.props.clientStore.has_connection} looker_cc_status_data={this.props.clientStore.looker_cc_status_data} />;
    }

    dataNodeColumnData() {
        return <DataNodeStatus hasConnection={this.props.clientStore.has_connection} data_node_status_data={this.props.clientStore.looker_cc_status_data} />;
    }

    mcpColumnData() {
        return <MCPStatus hasConnection={this.props.clientStore.has_connection} mcp_status_data={this.props.clientStore.looker_cc_status_data} />;
    }

    renderAccountColumnText() {
        return (
            <div style={{minWidth: "200px", paddingTop: "10px", paddingBottom: "10px"}}>
                <span style={{float: "left", paddingLeft: '0'}}>
                    <ChannelLogo useOld={false} width="20px" height={"20px"} channel={this.props.clientStore.channel} marginLeft={"5px"}/>
                </span>
                <span style={{float: "left", paddingLeft: '0'}}>
                    {this.props.clientStore.account_id}<br/>{this.props.clientStore.name}
                </span>
            </div>
        )
    }
}
